// Dependencies
import { Scrollbars } from 'react-custom-scrollbars-2';
import { connect } from 'react-redux';
import { Tooltip } from 'react-tooltip';

import Button from 'components/atoms/Button';
import FormGroup from 'components/atoms/FormGroup';
import Icon from 'components/atoms/Icon';
import Image from 'components/atoms/Image';
import Input from 'components/atoms/Input';
import ManagerBase from 'components/baseClass/ManagerBase';
import { PADGE_LIMIT } from 'data/static';
import { bindActionCreators, Dispatch } from 'redux';
import { tagRecords } from 'services/tags';
import {
    SetErrorHandlerAction,
    setErrorHandlerAction,
    SetSystemLoadingAction,
    setSystemLoadingAction,
} from 'store/actions/errorsActions';
import { OpenModal, PortType, RootState, UserType } from 'types';
import { clone, parseHtmlEntities } from 'utils/formHandlers';
import { translate } from 'utils/translate';
import { twclsx } from 'utils/twclsx';

interface TagsComponentProps {
    active: boolean;
    opendMenu?: boolean;
    setSystemLoadingAction: SetSystemLoadingAction;
    port: PortType;
    setErrorHandlerAction: SetErrorHandlerAction;
    openModelFunction: OpenModal;
    user: UserType;
}

interface TagsComponentState {
    active: boolean;
    opendMenu?: boolean;

    page: number;
    limit: number;

    //unused state
    searchFor: string[];

    order: {
        type: string;
        order: string;
    };
    searchQuery: any;
    searchValue: string;
    filterQuery: any;
    loading: boolean;
    pages: number;
    total: number;

    items: any[];
}

class Tags extends ManagerBase<TagsComponentProps, TagsComponentState> {
    constructor(props: TagsComponentProps) {
        super(props);
        this.state = {
            active: false,
            searchFor: ['tag'],
            opendMenu: false,
            searchValue: '',
            pages: 0,
            page: 1,
            limit: PADGE_LIMIT,
            total: 0,
            order: { type: 'id', order: 'desc' },
            searchQuery: {},
            filterQuery: {},
            loading: false,
            items: [],
        };
    }

    static getDerivedStateFromProps(props: TagsComponentProps, state: TagsComponentState) {
        if (props.active !== state.active || props.opendMenu !== state.opendMenu) {
            return {
                active: props.active,
                opendMenu: props.opendMenu,
            };
        }

        return null;
    }

    componentDidMount(): void {
        this.getData();
    }

    getData = () => {
        this.setState({ loading: true }, () => {
            tagRecords(this.props.port.id, {
                page: this.state.page, // send page number
                limit: this.state.limit,
                order: this.state.order, // send order value
                search: this.state.searchQuery, // send search value
                filter: this.state.filterQuery,
            })
                .then((res) => {
                    //update state and save the data
                    this.setState({
                        pages: Math.ceil(res.total / this.state.limit),
                        total: res.total,
                        items: res.items,
                        loading: false,
                    });
                    this.props.setSystemLoadingAction(false);
                })
                .catch((error) => {
                    this.props.setErrorHandlerAction(error);
                });
        });
    };

    handleToggleCreateTag = () => {
        this.props.openModelFunction(
            'createTagModel',
            0,
            'medium',
            {},
            {
                onCancel: () => {
                    this.props.openModelFunction('createTagModel');
                },
                onConfirm: this.getData,
            },
            true
        );
    };

    handleToggleEditTag = (tag) => {
        this.props.openModelFunction(
            'editTagModel',
            0,
            'medium',
            { tag },
            {
                onCancel: () => {
                    this.props.openModelFunction('editTagModel');
                },
                onConfirm: this.getData,
            },
            true
        );
    };

    togglDeleteTag = (tag) => {
        this.props.openModelFunction(
            'deleteTagModel',
            0,
            'medium',
            { tag },
            {
                onCancel: () => {
                    this.props.openModelFunction('deleteTagModel');
                },
                onConfirm: this.getData,
            },
            true
        );
    };

    toggleTagReassign = (tag) => {
        this.props.openModelFunction(
            'reassignTagModel',
            0,
            'medium',
            { tag },
            {
                onCancel: () => {
                    this.props.openModelFunction('reassignTagModel');
                },
                onConfirm: this.getData,
            },
            true
        );
    };

    toggleOrderTag = () => {
        this.props.openModelFunction(
            'orderTagModel',
            0,
            'auto',
            {},
            {
                onCancel: () => {
                    this.props.openModelFunction('orderTagModel');
                },
                onConfirm: () => this.getData,
            },
            true
        );
    };

    //unused function
    toggleFilter = () => {
        this.props.openModelFunction(
            'tagFilterModel',
            0,
            'medium',
            {
                filter: this.state.filterQuery,
            },
            {
                onCancel: () => {
                    this.props.openModelFunction('tagFilterModel');
                },
                onConfirm: this.setFilter,
            },
            true
        );
    };

    render() {
        return (
            <div
                className={twclsx(
                    !this.state.active && 'hidden',
                    'mt-14',
                    'h-page',
                    'border-gray-300',
                    'padding-transition',
                    'fixed',
                    'z-10',
                    'left-0',
                    'right-0',
                    'margin-transition',
                    this.state.opendMenu ? 'ml-menu w-main' : 'ml-14 w-fullPage'
                )}
            >
                <div className="flex no-select h-12 justify-between border-b border-gray-300  px-2">
                    <div className=" py-2  flex items-center">
                        <div className="py-0 px-0 w-1/4">
                            <FormGroup required={false} className="mb-0 mt-0 relative">
                                <Input
                                    value={this.state.searchValue}
                                    name="search"
                                    type="search"
                                    onChange={this.search}
                                    className="py-1 pl-5 w-48"
                                ></Input>
                                <Icon className="absolute left-1 bottom-1 mb-1  w-4 h-4">
                                    <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
                                    <path d="M21 21l-6 -6" />
                                </Icon>
                            </FormGroup>
                        </div>
                    </div>
                    <div className=" py-2 flex justify-end">
                        <div className="flex items-center gap-4">
                            <Button
                                onClick={() => this.handleToggleCreateTag()}
                                type="button"
                                className="px-4 py-1 bg-primary-submit rounded-md text-white"
                            >
                                {translate('Create new tag')}
                            </Button>
                            <Button
                                onClick={this.toggleOrderTag}
                                type="button"
                                className="px-4 py-1 bg-primary-submit rounded-md text-white"
                            >
                                {translate('Order tags')}
                            </Button>
                        </div>
                    </div>
                </div>
                <div className="grid  no-select h-10 grid-cols-24 border-b border-gray-300  ">
                    <div className=" py-2 col-span-1 flex items-center">
                        {this.renderOrder('id')}
                        {translate('#')}
                    </div>
                    <div className=" py-2 col-span-5 flex items-center">
                        {this.renderOrder('tag')}
                        {translate('TAG')}
                    </div>
                    <div className=" py-2 col-span-2 flex items-center">
                        {this.renderOrder('total')}
                        {translate('USED')}
                    </div>
                    <div className=" py-2 col-span-2 flex items-center">
                        {this.renderOrder('type')}
                        {this.renderFilter('type')}
                        {translate('TYPE')}
                    </div>
                    <div className=" py-2 col-span-3 flex items-center">
                        {this.renderOrder('user')}
                        {translate('USER')}
                    </div>
                    <div className=" py-2 col-span-5 flex items-center">
                        {this.renderOrder('label')}
                        {translate('LABEL')}
                    </div>
                    <div className=" py-2 col-span-1 flex items-center">
                        {this.renderOrder('order')}
                        {translate('ORDER')}
                    </div>
                    <div className=" py-2 col-span-2 flex items-center">
                        {this.renderOrder('autoApply')}
                        {translate('AUTO APPLY')}
                    </div>
                    <div className=" py-2 col-span-2 flex items-center">{translate('OPTIONS')}</div>
                </div>
                {this.state.loading ? (
                    <div
                        style={{
                            height: 'calc( 100vh - 190px)',
                        }}
                        className="flex items-center justify-center "
                    >
                        <div className="flex justify-start items-center gap-1 max-w-3xl mx-auto text-center  leading-9   text-gray-900">
                            <Image src="/static/images/loading.svg" className="mx-auto w-4" alt="error" />
                            <p>{translate('Loading, Please Wait...')}</p>
                        </div>
                    </div>
                ) : (
                    <>
                        <Scrollbars
                            renderThumbHorizontal={() => <div style={{ display: 'none' }} />}
                            renderTrackHorizontal={() => <div style={{ display: 'none' }} />}
                            style={{
                                height: 'calc( 100vh - 190px)',
                            }}
                        >
                            {this.state.items.map((item, index) => {
                                return (
                                    <div
                                        key={index}
                                        className={twclsx(
                                            'grid',
                                            'raw',
                                            'grid-cols-24',
                                            'border-b',
                                            'border-gray-300',

                                            'relative'
                                        )}
                                    >
                                        <div className=" py-2 px-2 col-span-1 flex items-center">{item.id}</div>
                                        <div className=" py-2 col-span-5 flex items-center">
                                            <span
                                                data-ToolTip-id={`tagActiveComment-${item.id}`}
                                                className={`flex  align-top  mt-1 ${
                                                    item.status === 'active' ? 'text-gray-700' : 'text-gray-400'
                                                }`}
                                            >
                                                <Tooltip
                                                    id={`tagActiveComment-${item.id}`}
                                                    html={
                                                        item.status === 'active'
                                                            ? translate('Active tag')
                                                            : translate('This tag is not used in config')
                                                    }
                                                    place={'right'}
                                                />

                                                {(item.type === 'type' || item.type === 'system') &&
                                                item.port_id === null ? (
                                                    <Icon className="W-3 h-3 mr-2 my-1 text-red-500">
                                                        <path d="M17.286 21.09q -1.69 .001 -5.288 -2.615q -3.596 2.617 -5.288 2.616q -2.726 0 -.495 -6.8q -9.389 -6.775 2.135 -6.775h.076q 1.785 -5.516 3.574 -5.516q 1.785 0 3.574 5.516h.076q 11.525 0 2.133 6.774q 2.23 6.802 -.497 6.8"></path>
                                                    </Icon>
                                                ) : null}

                                                {parseHtmlEntities(item.tag)}
                                            </span>
                                        </div>
                                        <div className=" py-2 col-span-2 flex items-center">
                                            {item.type === 'type' && item.port_id === null ? (
                                                <span className="flex  align-top mt-1 capitalize text-gray-700">
                                                    {item.total} / {item.count}
                                                </span>
                                            ) : (
                                                <span className="flex  align-top mt-1 capitalize  text-gray-700">
                                                    {item.total}
                                                </span>
                                            )}
                                        </div>
                                        <div className=" py-2 col-span-2 flex items-center">{translate(item.type)}</div>
                                        <div className=" py-2 col-span-3 flex items-center">
                                            {item.user
                                                ? `${item.user?.first_name} ${item.user?.last_name}`
                                                : translate('None')}
                                        </div>
                                        <div className=" py-2 col-span-5 flex items-center">
                                            {parseHtmlEntities(item.label)}
                                        </div>
                                        <div className=" py-2 col-span-1 flex items-center">{item.order}</div>
                                        <div className=" py-2 col-span-2 flex items-center">
                                            {translate(item.autoApply)}
                                        </div>
                                        <div className=" py-2 gap-1  col-span-2 flex items-center">
                                            {(!['system', 'admin', 'type', 'private'].includes(item.type) &&
                                                (item.type !== 'positioning' ||
                                                    (item.status === 'inactive' && item.type === 'positioning')) &&
                                                item.port_id != null) ||
                                            (item.type === 'private' && item.user_id === this.props.user.id) ? (
                                                <Button
                                                    type="button"
                                                    onClick={() => {
                                                        this.handleToggleEditTag(clone(item));
                                                    }}
                                                    className="px-2 py-0 bg-primary-submit text-sm rounded-md text-white "
                                                >
                                                    {translate('Edit')}
                                                </Button>
                                            ) : null}
                                            {item.type === 'type' && item.count === 0 ? (
                                                <Button
                                                    type="button"
                                                    onClick={() => {
                                                        this.togglDeleteTag(item);
                                                    }}
                                                    className="px-2 py-0 bg-primary-delete text-sm rounded-md text-white"
                                                >
                                                    {translate('Delete')}
                                                </Button>
                                            ) : null}
                                            {(!['system', 'admin', 'type', 'private'].includes(item.type) &&
                                                ((item.total === 0 && item.type !== 'positioning') ||
                                                    item.user_id === this.props.user.id ||
                                                    (item.total === 0 &&
                                                        item.status === 'inactive' &&
                                                        item.type === 'positioning')) &&
                                                item.port_id != null) ||
                                            (item.type === 'private' && item.user_id === this.props.user.id) ? (
                                                <Button
                                                    type="button"
                                                    onClick={() => {
                                                        this.togglDeleteTag(item);
                                                    }}
                                                    className="px-2 py-0 bg-primary-delete text-sm rounded-md text-white"
                                                >
                                                    {translate('Delete')}
                                                </Button>
                                            ) : null}
                                            {item.total !== 0 && (
                                                <Button
                                                    type="button"
                                                    onClick={() => {
                                                        this.toggleTagReassign(item);
                                                    }}
                                                    className="px-2 py-0 bg-blue-500 text-sm rounded-md text-white"
                                                >
                                                    {translate('Reassign')}
                                                </Button>
                                            )}{' '}
                                        </div>
                                    </div>
                                );
                            })}
                        </Scrollbars>
                    </>
                )}
                <div className="flex h-10 p-1 justify-between border-t border-gray-300  ">
                    <div className="w-36 flex text-center ">{this.renderPages()}</div>
                    <p className="  py-2 px-2 text-gray-700">
                        {translate('pagination', {
                            showingFrom: (this.state.page - 1) * this.state.limit + 1,
                            showingTo:
                                (this.state.page - 1) * this.state.limit + this.state.limit > this.state.total
                                    ? this.state.total
                                    : (this.state.page - 1) * this.state.limit + this.state.limit,
                            of: this.state.total,
                        })}
                    </p>
                </div>
            </div>
        );
    }
}

const tagsStateToProps = (state: RootState) => ({
    port: state.port.port,
    user: state.user.user,
    openModelFunction: state.layout.openModelFunction,
});

const tagsDispatchToProps = (dispatch: Dispatch) => ({
    setSystemLoadingAction: bindActionCreators(setSystemLoadingAction, dispatch),
    setErrorHandlerAction: bindActionCreators(setErrorHandlerAction, dispatch),
});

export default connect(tagsStateToProps, tagsDispatchToProps)(Tags);
